import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppSettings } from '@model/app-settings';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, firstValueFrom, lastValueFrom, takeUntil } from 'rxjs';
import * as AppSelectors from '../store/selectors/app.selectors';
import * as AppActions from '../store/actions/app.actions';

export enum FontSize {
  ExtraSmall,
  Small,
  Default,
  Large,
  ExtraLarge,
}

@Component({
  selector: 'app-settings-form',
  templateUrl: './settings-form.component.html',
  styleUrl: './settings-form.component.scss'
})
export class SettingsFormComponent implements OnInit, OnDestroy {

  constructor(
    private translate: TranslateService,
    private store: Store<{}>,
  ) {

  }

  destroy$: Subject<boolean> = new Subject<boolean>();


  appSettings$: Observable<AppSettings> = this.store.pipe(select(AppSelectors.selectAppSettings));
  appSettings: AppSettings = {
    fontSize: {
      reservationList: FontSize.Default,
      reservationForm: FontSize.Default,
      tablesPlan: FontSize.Default,
    }
  };
  
  editingAppSettings$: Observable<AppSettings> = this.store.pipe(select(AppSelectors.selectEditingAppSettings));
  editingAppSettings: AppSettings = {
    fontSize: {
      reservationList: FontSize.Default,
      reservationForm: FontSize.Default,
      tablesPlan: FontSize.Default,
    }
  };

  fontSizeOptions: { display: string, value: FontSize }[] = [
    { display: this.translate.instant('settings.fontSizes.extraSmall'), value: FontSize.ExtraSmall },
    { display: this.translate.instant('settings.fontSizes.small'), value: FontSize.Small },
    { display: this.translate.instant('settings.fontSizes.default'), value: FontSize.Default },
    { display: this.translate.instant('settings.fontSizes.large'), value: FontSize.Large },
    { display: this.translate.instant('settings.fontSizes.extraLarge'), value: FontSize.ExtraLarge },
  ];

  reservationsListFontSize: FontSize = FontSize.Default;

  async ngOnInit(): Promise<void> {

    this.appSettings$.pipe(takeUntil(this.destroy$)).subscribe((appSettings: AppSettings) => {
      this.appSettings = appSettings;
    });

    this.editingAppSettings$.pipe(takeUntil(this.destroy$)).subscribe((editingAppSettings: AppSettings) => {
      this.editingAppSettings = editingAppSettings;
    });

    const appSettings = await firstValueFrom(this.appSettings$);
    this.store.dispatch({ type: AppActions.setEditingAppSettings.type, appSettings });
  }

  setFontSize(form: string, size: FontSize) {

    const appSettings = JSON.parse(JSON.stringify(this.editingAppSettings));

    switch (form) {
      case 'reservationList':
        appSettings.fontSize.reservationList = size;
        break;
      case 'reservationForm':
        appSettings.fontSize.reservationForm = size;
        break;
      case 'tablesPlan':
        appSettings.fontSize.tablesPlan = size;
        break;
    }

    this.store.dispatch({ type: AppActions.setEditingAppSettings.type, appSettings });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
